import { Placement } from 'react-bootstrap/esm/Overlay';
import { followCursor } from 'tippy.js';
import StyledTooltip from './style';

interface PropsI {
  textTooltip: string;
  followingTooltip: boolean;
  position: Placement | undefined;
  arrow: boolean;
  theme: string | null;
  children: JSX.Element;
}

const Tooltip = ({
  textTooltip,
  followingTooltip,
  position,
  arrow,
  theme,
  children,
}: PropsI): JSX.Element => {
  return (
    <StyledTooltip
      content={textTooltip}
      followCursor={followingTooltip}
      plugins={[followCursor]}
      placement={position}
      arrow={arrow}
      theme={theme}
    >
      {children}
    </StyledTooltip>
  );
};

export default Tooltip;
